<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Ghostly Tales of Lake Tahoe</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span> &amp; M<span class="small">AP</span> K<span class="small">EY</span></p>
<table>
<colgroup>
<col width="70px"/>
<col width="320px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Welcome_to_Spooky_Lake_Tahoe#Wel">Welcome to Spooky Lake Tahoe!</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Chapter 1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">The Mythical Beasts of Tahoe</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Chapter 2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">The Lake Never Gives Up Its Dead</span></td></tr>
<tr><td>2</td><td>Hellman-Ehrman Mansion</td></tr>
<tr><td>3</td><td>Emerald Bay</td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">Chapter 3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">The Ghostly Thunderbird Lodge</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Chapter 4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">Spooky Shores and Summits</span></td></tr>
<tr><td>5</td><td>Shakespeare Point</td></tr>
<tr><td>6</td><td>Genoa Peak</td></tr>
<tr><td>7</td><td>Glenbrook</td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Chapter 5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Celebrity Ghosts at the Cal Neva</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Chapter 6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Two Ghosts Named Mary</span></td></tr>
<tr><td>9</td><td>Rainbow Lodge</td></tr>
<tr><td>10</td><td>Tahoe Biltmore Lodge &amp; Casino</td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Chapter 7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">Haunted Highways</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Chapter 8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">Hard Rock Hauntings</span></td></tr>
<tr><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Chapter 9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Terrified in Truckee</span></td></tr>
<tr><td>13</td><td>Old Jail Museum</td></tr>
<tr><td>14</td><td>The Richardson House</td></tr>
<tr><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Chapter 10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">The Sad Tale of the Donner Party</span></td></tr>
<tr><td colspan="2"><span href="#/A_Ghostly_Goodbye#Gho" title="Link target outside of Sample">A Ghostly Goodbye</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?5069e5f9